export const donutChartI18NPl = {
    projectLabel: "Wszystkie projekty",
    userLabel: "Wszyscy użytkownicy",
    othersLabel: "Reszta",
};
